import { render, staticRenderFns } from "./maintenance-detail.vue?vue&type=template&id=51405b76&scoped=true&"
import script from "./maintenance-detail.vue?vue&type=script&lang=ts&"
export * from "./maintenance-detail.vue?vue&type=script&lang=ts&"
import style0 from "./maintenance-detail.vue?vue&type=style&index=0&id=51405b76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51405b76",
  null
  
)

export default component.exports